module.exports = __webpack_public_path__ + "static/media/gitlab.73e2273e.svg";